import {Component, Inject, LOCALE_ID} from '@angular/core';
import {Role} from '../../../model/auth/Role';
import {MobileAwareComponent} from '../../../common/mobile-aware/mobile-aware.component';
import {BreakpointObserver} from '@angular/cdk/layout';
import {Contest} from '../../../model/contest/Contest';
import {Region} from '../../../model/location/Region';
import {AuthService} from '../../../service/auth.service';
import {NotificationHandler} from '../../../helper/notification.handler';
import {School, SchoolType} from '../../../model/location/School';
import {User} from '../../../model/auth/User';
import {LocationService} from '../../../service/location.service';
import {TenantService} from '../../../service/tenant.service';
import {Session} from '../../../model/auth/Session';
import {UrlHelper} from '../../../helper/url.helper';
import {Params} from '@angular/router';

@Component({
  selector: 'app-printable-report-stats',
  templateUrl: './printable-report-stats.component.html',
  styleUrls: ['./printable-report-stats.component.scss']
})
export class PrintableReportStatsComponent extends MobileAwareComponent {

  readonly roles = [Role.Host, Role.Coordinator];

  competitionId?: string;

  user?: User | null = null;
  session?: Session;
  callerRegion?: Region;
  callerSchool?: School;

  contest?: Contest;

  region?: Region;
  schoolType?: SchoolType;
  school?: School;

  inProgress = false;

  constructor(private locationService: LocationService,
              private authService: AuthService,
              private tenantService: TenantService,
              @Inject(LOCALE_ID) private locale: string,
              breakpointObserver: BreakpointObserver) {
    super(breakpointObserver);
  }

  async initContent() {
    const tenant = this.tenantService.getTenant();
    if (tenant && tenant.id) {
      this.competitionId = tenant.id;
    }

    const user = await this.authService.getUser();
    if (user) {
      if (user.region) {
        this.region = new Region(user.region, '');
        this.callerRegion = new Region(user.region, '');
      }
    }

    if (user && user.schoolId) {
      this.loadSchool(user.schoolId, user);
      this.callerSchool = new School(user.schoolId, '');
    } else {
      this.school = undefined;
      this.user = user;
    }
    this.session = await this.authService.getSession();
  }

  loadSchool(schoolId: string, user: User) {
    this.inProgress = true;

    this.locationService.getSchoolDetails(schoolId).subscribe(school => {
      this.school = school;
      this.schoolType = new SchoolType(school.type, '');

      this.user = user;
      this.inProgress = false;
    }, error => {
      NotificationHandler.handleError($localize`:Notifications|School details fetch has failed message@@notifications-school-details-fetch-failed-error:School details fetch has failed`, error);
    });
  }

  get getPrintUrl(): string {
    return `${UrlHelper.STATS_SCHOOL_RATING_PATH}/${this.contest?.id}/${this.region?.id}`;
  }

  get getRegionSchoolsResultPrintUrl(): string {
    return `${UrlHelper.STATS_REGION_SCHOOLS_PATH}/${this.contest?.id}/${this.region?.id}`;
  }

  get getPrintUrlQueryParams(): Params {
    return {
      school_id: this.school?.id || ''
    };
  }

  regionSelected(region: Region) {
    this.region = region;
  }

  schoolSelected(school?: School, region?: Region) {
    const schoolChanged = this.school != school;
    this.school = school;
    if (schoolChanged) this.region = region;
  }

  contestSelected(contest: Contest) {
    this.contest = contest;
  }
}
